import React from 'react';
import moment from 'moment';

interface CustomCalendarHeaderProps {
	date: Date;
}

const CustomCalendarHeader: React.FC<CustomCalendarHeaderProps> = ({ date }) => (
	<div className="flex flex-col items-start px-2 py-2">
		<span className="footnoteregular uppercase text-character-secondary">
			{moment(date).format('ddd')}
		</span>
		<span className="h5medium text-character-primary">{moment(date).format('DD')}</span>
	</div>
);

export default CustomCalendarHeader;
